'use client'

import { setRequestHeaders } from '../fetcher/client'
import { glovoRum } from '../o11y/client'
import type { TogglesDictionary } from '../toggles/types'
import { createDevice } from './device'
import { initFingerprint, initThumbmark } from './fingerprint'
import { initIncognia } from './providers/incognia'
import { getErrorMessage, getStatusCode, hasStatusCode } from '@/tools/error-handling'

export { createDevice, updateDevice, getDeviceUrn } from './device'

export const initDeviceDetection = async ({
  toggles,
  userId,
}: {
  toggles?: TogglesDictionary
  userId?: string
}) => {
  const isThumbmarkEnabled = toggles?.WEB_THUMBMARK_ENABLED || false
  try {
    const initFingerprintProvider = isThumbmarkEnabled ? initThumbmark : initFingerprint
    await Promise.all([initFingerprintProvider(), initIncognia()])
    const urn = await createDevice({ isThumbmarkEnabled, userId })

    if (urn) {
      setRequestHeaders('Glovo-Device-Urn', urn)
    }
    glovoRum.addAction('device_detection.init.success', { domain: 'device_detection' })
    // eslint-disable-next-line @glovo/custom-rules/always-forward-error
  } catch (e) {
    const errorMessage = getErrorMessage(e)
    if (errorMessage.includes('Client timeout')) {
      glovoRum.addAction('device_detection.init.timeout', {
        domain: 'device_detection',
        provider: isThumbmarkEnabled ? 'ThumbmarkJS' : 'FingerprintJS',
      })
    } else if (errorMessage.includes('reached an API limit') || hasStatusCode(e, 429)) {
      glovoRum.addAction('device_detection.devices.fetch_fail', {
        domain: 'device_detection',
        errorMessage,
        statusCode: getStatusCode(e),
      })
    } else {
      glovoRum.addError(e as Error, {
        domain: 'device_detection',
        provider: isThumbmarkEnabled ? 'ThumbmarkJS' : 'FingerprintJS',
      })
    }
  }
}
